const doc = [({"en":({"js":({"admin":({"show_boxes":({"form":({"the_show_box_was_saved":"The show box was saved."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;